import IconField, { IconName } from '@/components/customFields/IconField';
import MultiLineField from '@/components/customFields/MultiLineField';
import { RichText as RichTextComponent } from '@/components/richText/RichText';
import type { GlobalFooterStoryblok } from '@/types/component-types-sb';

import classes from './Contact.module.scss';

const Contact: React.FC<{ blok: GlobalFooterStoryblok }> = ({ blok }) => {
  return (
    <div className={classes.Contact}>
      <div className={classes.section}>
        <IconField iconName={blok.mail_icon as IconName} aria-hidden={true} />
        <div className={classes.textWrapper}>
          <div className={classes.contactHeading}>{blok.mail_headline}</div>
          <RichTextComponent noLinkStyle={true} className={classes.text} text={blok.mail_text} />
        </div>
      </div>
      <div className={classes.section}>
        <IconField iconName={blok.hotline_icon as IconName} aria-hidden={true} />
        <div className={classes.textWrapper}>
          <div className={classes.contactHeading}>{blok.hotline_headline}</div>
          <RichTextComponent noLinkStyle={true} className={classes.text} text={blok.hotline_text} />
        </div>
      </div>
      <div className={classes.section}>
        <div className={classes.textWrapper}>
          <div className={classes.contactHeading}>{blok.opening_hours_headline}</div>
          <p className={classes.text}>
            <MultiLineField text={blok.opening_hours} />
          </p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
